import * as React from 'react'

export default () => (
  <svg width="28" height="28" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.0215 12.7725C14.361 11.3807 16.6059 11.4703 17.8418 12.9258L17.958 13.0713C18.5753 13.8866 18.7734 14.9425 18.501 15.9189L18.4404 16.1133L17.501 18.8145L17.4951 18.832L17.4902 18.8486L15.4648 25.7236C15.3153 26.2313 14.6317 26.263 14.416 25.8184L14.3799 25.7236L13.1201 21.4326L13.083 21.3242C12.6791 20.2782 11.1743 20.278 10.7705 21.3242L10.7344 21.4326L9.47461 25.7236C9.32551 26.2311 8.64211 26.2632 8.42578 25.8193L8.38867 25.7236L6.36426 18.8486L6.35938 18.832L6.35254 18.8145L5.41309 16.1133C5.0777 15.1488 5.21701 14.0833 5.77832 13.2373L5.89551 13.0713C7.06431 11.5276 9.30422 11.3461 10.7002 12.6426L10.833 12.7725C11.3932 13.3542 12.3016 13.391 12.9053 12.8818L13.0215 12.7725Z"
      fill="#8FB4FF"
      stroke="#8FB4FF"
      strokeWidth="1.5"
    />
    <path
      d="M25.9452 11.1416L24.1492 11.7403C22.9398 12.1434 21.9904 13.0928 21.5873 14.3022L20.9886 16.0983L20.2773 18.2334L19.5661 16.0983L18.9674 14.3022C18.5895 13.1685 17.7314 12.264 16.6293 11.8232L16.4055 11.7403L14.6094 11.1416L12.475 10.431L14.6094 9.71911L16.4055 9.12042L16.6293 9.03893C17.7316 8.59812 18.5895 7.69238 18.9674 6.55854L20.2773 2.62871L21.5873 6.55854C21.9904 7.76789 22.9398 8.7173 24.1492 9.12042L25.9452 9.71911L28.0797 10.431L25.9452 11.1416Z"
      fill="#8FB4FF"
      stroke="#EEF0FF"
      strokeWidth="1.5"
    />
  </svg>
)
